import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./PlaceholderBlock.module.css";

function PlaceholderBlock({
    class: cssClass,
    ...nativeDivProps
}: JSX.HTMLAttributes<HTMLDivElement>) {
    return (
        <div {...nativeDivProps} class={classname(styles.placeholderBlock, cssClass)}/>
    );
}

export default PlaceholderBlock;
